// Medianoche de Ecuador continental (America/Guayaquil), independiente del huso del visitante.
export const RESULTS_AVAILABLE_AT = '2026-11-29T00:00:00-05:00'
export const RESULTS_AVAILABLE_TIMESTAMP = Date.parse(RESULTS_AVAILABLE_AT)

export function areResultsAvailable(now = Date.now()) {
  return now >= RESULTS_AVAILABLE_TIMESTAMP
}
